import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.5938 21L7.59375 12L16.5937 3",
      stroke: "#454342",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }